import { render, staticRenderFns } from "./AtlasConsolidatedTransferOutReport.vue?vue&type=template&id=35c50c12"
import script from "./AtlasConsolidatedTransferOutReport.vue?vue&type=script&lang=js"
export * from "./AtlasConsolidatedTransferOutReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports